import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";

const StyledNav = styled.div`
  color: white;
  font-size: 1rem;
  line-height: 2rem;
  font-family: ${(props) => props.theme.font.sans};
  margin-right: 0;
  ${(props) => props.theme.responsive.mobile} {
    font-size: 0.7rem;
    margin-right: 100px;
  }
`;

const StyledLink = styled.div`
  color: ${(props) => props.theme.color.grey};

  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.color.white};
  }
`;

export default function Botbar({ ...props }) {
  const intl = useIntl();
  return (
    <StyledNav>
      <Link to="/">
        <StyledLink>{intl.formatMessage({ id: `botbar.nav.home` })}</StyledLink>
      </Link>
      <Link to="/faq">
        <StyledLink>{intl.formatMessage({ id: `botbar.nav.faq` })}</StyledLink>
      </Link>
      <Link to="/privacy-policy">
        <StyledLink>
          {intl.formatMessage({ id: `botbar.nav.privacyPolicy` })}
        </StyledLink>
      </Link>
      <Link to="/terms-of-service">
        <StyledLink>
          {intl.formatMessage({ id: `botbar.nav.termsOfService` })}
        </StyledLink>
      </Link>
    </StyledNav>
  );
}
